import makeRequest from './utils/makeRequest';

const makeRequestWithMethod = async (
    url,
    options,
    method,
    cacheOptions = {},
) => {
    const {
        headers,
        abortControllerCallback,
        body,
        queryParams,
        timeout,
        credentials,
        shouldIncludeResponseAttributes = false,
    } = options ?? {};

    const { isCacheable, shouldOverwriteCache } = cacheOptions ?? {};

    return makeRequest(url, {
        method,
        headers,
        abortControllerCallback,
        body,
        queryParams,
        timeout,
        credentials,
        shouldOverwriteCache,
        isCacheable,
        shouldIncludeResponseAttributes,
    });
};

export const get = async (url, options) => {
    return makeRequestWithMethod(url, options, 'GET');
};

export const cachedGet = async (url, options) => {
    const { shouldOverwriteCache, ...getOptions } = options ?? {};

    return makeRequestWithMethod(url, getOptions, 'GET', {
        isCacheable: true,
        shouldOverwriteCache,
    });
};

export const post = async (url, options) => {
    return makeRequestWithMethod(url, options, 'POST');
};

export const patch = async (url, options) => {
    return makeRequestWithMethod(url, options, 'PATCH');
};

export const deleteRequest = async (url, options) => {
    return makeRequestWithMethod(url, options, 'DELETE');
};

export const put = async (url, options) => {
    return makeRequestWithMethod(url, options, 'PUT');
};

export const head = async (url, options) => {
    const headOptions = options ?? {};
    headOptions.shouldIncludeResponseAttributes = true;

    return makeRequestWithMethod(url, headOptions, 'HEAD');
};

export const upload = async () => {};
